import React from 'react';

import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useHistory, useRouteMatch } from 'react-router-dom';
import styled from 'styled-components';

import UserFilterTools from '../components/AdminUsers/UserFilterTools';

const FirstRow = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 1rem;
`;

const StyledButton = styled(Button)`
    margin-right: auto;
`;

interface UsersAdminToolbarProps {}

const UsersAdminToolbar: React.FC<UsersAdminToolbarProps> = () => {
    const { t } = useTranslation('admin_settings');
    const history = useHistory();
    const { path } = useRouteMatch();

    const handleAddUser = () => {
        history.push(`${path}/add`);
    };

    return (
        <div>
            <FirstRow>
                <StyledButton onClick={() => handleAddUser()} variant="contained">
                    {t('users.actions.add-users')}
                </StyledButton>
                <UserFilterTools />
            </FirstRow>
        </div>
    );
};

export default UsersAdminToolbar;
